import MapViewLoading from "./map-view-loading";
import styles from "./map-view.module.css";

export default function MapWrapperServer() {
  return (
    <div className={styles.mapContainerWrapper}>
      <MapViewLoading />
    </div>
  );
}
